<app-mas-garantia-header></app-mas-garantia-header>
<app-mas-garantia-navbar>
    <div class="row justify-content-center vh-70 m-0 p-0">
        <div class="col-12 col-lg-10 d-flex m-0 p-0">
            <div class="row mx-0 my-auto p-0 w-100">
                <div class="col-12 col-md-6 d-flex flex-column justify-content-center align-items-cente m-0">
                    <div>
                        <p class="fs-5 ">Hola <b>Alberto</b></p>
                        <p class="fs-5 mb-5">¡Bienvenido! En esta sección podrás:</p>
                    </div>
                    <div class="d-flex flex-column">
                        <div class="d-flex aling-items-center mb-4">
                            <mat-icon class="primary-color">done</mat-icon>
                            <span class="ms-3"> 
                                Revisar tus productos con +Garantía
                            </span>
                        </div>
        
                        <div class="d-flex aling-items-center mb-4">
                            <mat-icon class="primary-color">done</mat-icon>
                            <span class="ms-3"> 
                                Solicitar un servicio por falla
                            </span>
                        </div>
        
                        <div class="d-flex aling-items-center mb-4">
                            <mat-icon class="primary-color">done</mat-icon>
                            <span class="ms-3"> 
                                Dar seguimiento a tu trámite
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 d-flex flex-column justify-content-end align-items-center p-0 m-0">
                    <p>Ingresa el número de referecia del ticket de tu garantía</p>
                    <form [formGroup]="ticketForm" (submit)="validateTicket()">
                        <div class="d-flex flex-column">
                            <input formControlName="ticket" type="text" class="my-3 px-2 rounded">
                            <mat-error *ngIf="ticketForm.controls['ticket'].touched && ticketForm.controls['ticket'].invalid" class="text-center mb-2">
                                <span>Número invalido</span>
                            </mat-error>
                            <button type="submit" class="mb-4 btn-w btn-h primary-bg-color" 
                            mat-flat-button color="accent">Registrar falla</button>        
                        </div>             
                    </form>
                </div>
            </div>
        </div>
    </div>
</app-mas-garantia-navbar>
<app-mas-garantia-footer></app-mas-garantia-footer>